import { SummaryStatsCard } from '@exam-center/components';
import { useAdminGetExamCenterProctorRequestsCountQuery } from '@exam-center/graphql';
import { Flex } from '@shared/components';
import { useMemo } from 'react';

export default function AdminProctorRequestSummaryStatuses() {
  const { data, loading: isLoading } = useAdminGetExamCenterProctorRequestsCountQuery({
    variables: {
      getExamCenterProctorRequestsCountInput: {
        examCenterCode: null,
      },
    },
  });

  const { numberOfInReview, numberOfRejected } = useMemo(() => {
    const proctorRequestCount =
      data?.ecAdminGetExamCenterProctorRequestsCountByExamCenterCode.proctorRequestCountByStatus;

    return {
      numberOfInReview: proctorRequestCount?.IN_REVIEW ?? 0,
      numberOfRejected: proctorRequestCount?.REJECTED ?? 0,
    };
  }, [data?.ecAdminGetExamCenterProctorRequestsCountByExamCenterCode]);

  return (
    <Flex sx={(theme) => ({ gap: theme.spacing(4) })}>
      <SummaryStatsCard
        title='อยู่ระหว่างอนุมัติ'
        displayValue={`${numberOfInReview} รายการ`}
        loading={isLoading}
        color='warning'
      />
      <SummaryStatsCard
        title='ไม่อนุมัติ'
        displayValue={`${numberOfRejected} รายการ`}
        loading={isLoading}
        color='error'
      />
    </Flex>
  );
}
